import React from 'react';
import cn from 'classnames';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { alertAtom } from '@shared/store/slice-atoms';
import { dismissAlert } from '@shared/store/slices/alert.actions';

const Alert = () => {
  const alerts = useAtomValue(alertAtom);
  const { t } = useTranslation();

  return (
    <>
      {alerts !== null &&
        alerts.length > 0 &&
        alerts.map((alert) => (
          <div key={alert.id} className={cn('alert', `alert-${alert.alertType}`)}>
            {alert.msg?.message || alert.msg}
            {alert.dismissible ? (
              <button
                type="button"
                onClick={() => dismissAlert(alert.id)}
                aria-label={String(t('dismiss'))}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'inherit',
                  cursor: 'pointer',
                  fontSize: 16,
                  lineHeight: 1,
                  marginInlineStart: 8,
                  padding: 0,
                }}
              >
                ×
              </button>
            ) : null}
          </div>
        ))}
    </>
  );
};

export default Alert;
